export default "__VITE_ASSET__C37aF8PN__"